module.exports = __webpack_public_path__ + "340c7b1e27b7f03869de7107501fa858.MP3";